<template>
  <div class="trip-info-wrapper cw-ws">
    <T1TripInfoWidgetPart>
      <template v-slot:header>
        <span class="font-m">{{ depLabel }}</span>
        <span>{{ formatDate(tripDetails.depDate) }}</span>
      </template>

      <template v-slot:startIcon v-if="tripDetails.type != 'F'">
        <use xlink:href="/img/static/svg-sprites.svg#icon-bus"></use>
      </template>

      <template v-slot:endIcon v-if="tripDetails.type != 'F'">
        <use xlink:href="/img/static/svg-sprites.svg#icon-trip-finish"></use>
      </template>

      <template
        v-slot:depTime
        v-if="tripDetails.depTime != '0000' || tripDetails.arrTime != '0000'"
      >
        <span class="d-block font-m">{{
          formatTime(tripDetails.depTime)
        }}</span>
      </template>
      <template v-slot:depDetails>
        <span class="gray-40">{{ tripDetails.depCode }} </span>
        <span class="d-md-block">{{ tripDetails.depDesc }}</span>
      </template>

      <template
        v-slot:arrTime
        v-if="tripDetails.depTime != '0000' || tripDetails.arrTime != '0000'"
      >
        <span class="d-block font-m">{{
          formatTime(tripDetails.arrTime)
        }}</span>
      </template>
      <template v-slot:desDetails>
        <span class="gray-40">{{ tripDetails.desCode }} </span>
        <span class="d-md-block">{{ tripDetails.desDesc }}</span>
      </template>
    </T1TripInfoWidgetPart>
    <T1TripInfoWidgetPart>
      <template v-slot:header>
        <span class="font-m">Powrót:</span>
        <span>{{ formatDate(tripDetails.rDepDate) }}</span>
      </template>

      <template v-slot:startIcon v-if="tripDetails.type != 'F'">
        <use xlink:href="/img/static/svg-sprites.svg#icon-bus"></use>
      </template>

      <template v-slot:endIcon v-if="tripDetails.type != 'F'">
        <use xlink:href="/img/static/svg-sprites.svg#icon-trip-finish"></use>
      </template>

      <template
        v-slot:depTime
        v-if="tripDetails.rDepTime != '0000' || tripDetails.rArrTime != '0000'"
      >
        <span class="d-block font-m">{{
          formatTime(tripDetails.rDepTime)
        }}</span>
      </template>
      <template v-slot:depDetails>
        <span class="gray-40">{{ tripDetails.desCode }} </span>
        <span class="d-md-block">{{ tripDetails.desDesc }}</span>
      </template>

      <template
        v-slot:arrTime
        v-if="tripDetails.rDepTime != '0000' || tripDetails.rArrTime != '0000'"
      >
        <span class="d-block font-m">{{
          formatTime(tripDetails.rArrTime)
        }}</span>
      </template>
      <template v-slot:desDetails>
        <span class="gray-40">{{ tripDetails.depCode }} </span>
        <span class="d-md-block">{{ tripDetails.depDesc }}</span>
      </template>
    </T1TripInfoWidgetPart>
  </div>
</template>

<script>
import T1TripInfoWidgetPart from "./T1TripInfoWidgetPart";
import moment from "moment";
import "moment/locale/pl";
moment.locale("pl");

export default {
  props: {
    tripDetails: [Array, Object]
  },
  data: () => ({
    depLabel: ""
  }),
  methods: {
    setLabel() {
      if (this.tripDetails.type == "F") {
        this.depLabel = "Wylot: ";
      } else {
        this.depLabel = "Wyjazd: ";
      }
    },
    formatDate(data) {
      if (data != "" && data.length >= 8) {
        let dateFormatted =
          data.substring(0, 4) +
          "-" +
          data.substring(4, 6) +
          "-" +
          data.substring(6);
        return moment(dateFormatted).format("dd, D MMMM YYYY");
      } else {
        return "";
      }
    },
    formatTime(time) {
      if (time != "" && time.length >= 4) {
        let timeFormatted = time.substring(0, 2) + ":" + time.substring(2, 4);
        return timeFormatted;
      } else {
        return "";
      }
    }
  },
  mounted() {
    this.setLabel();
  },
  components: {
    T1TripInfoWidgetPart
  }
};
</script>

<style lang="scss" scoped>
.trip-info-wrapper {
  @media (min-width: $screen-sm) and (max-width: $screen-sm-max) {
    display: flex;
  }
}
</style>
